import TrackerPanel from "@/ui/action-panel/TrackerPanel.vue";
import {ActionPanelInstance} from "@t/ui/ActionPanel.ts";
import EventInvitationPanel from "@/ui/action-panel/EventInvitationPanel.vue";
import PbxPanel from "@/ui/action-panel/PbxPanel.vue";

export function resoveActionPanelComponent(type: string) {
	switch (type) {
		case "tracker":
			return TrackerPanel;
		case "invitation":
			return EventInvitationPanel;
		case "pbx":
			return PbxPanel;
	}
	throw "Invalid action panel type " + type;
}

export function panelBinding(panel:ActionPanelInstance<any>):Record<string, any> {
	if (panel?.bind) return panel.bind
	return {};
}